import React from 'react'

import { capitalizeBillerName } from 'utils/capitalizeBillerName'

import { ReactComponent as IconGlo } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/glo.svg"
import { ReactComponent as IconMtn } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/mtn.svg"
import { ReactComponent as IconAirtel } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/airtel.svg"
import { ReactComponent as IconNineMobile } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/nineMobile.svg"
import { ReactComponent as IconSmile } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/smile.svg"
import { ReactComponent as IconSpectranet } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/spectranet.svg"
import { ReactComponent as IconSwift } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/swift.svg"
// import { ReactComponent as IconDstvShowMax } from "assets/images/icons/project-icons/billPaymentProviders/airtimeData/dstvshowmax.svg"


import { ReactComponent as IconDstv } from "assets/images/icons/project-icons/billPaymentProviders/cable/dstv.svg"
import { ReactComponent as IconGotv } from "assets/images/icons/project-icons/billPaymentProviders/cable/gotv.svg"
import { ReactComponent as IconStartimes } from "assets/images/icons/project-icons/billPaymentProviders/cable/startimes.svg"

import { ReactComponent as IconAba } from "assets/images/icons/project-icons/billPaymentProviders/power/aba.svg"
import { ReactComponent as IconAbuja } from "assets/images/icons/project-icons/billPaymentProviders/power/abuja.svg"
import { ReactComponent as IconBenin } from "assets/images/icons/project-icons/billPaymentProviders/power/benin.svg"
import { ReactComponent as IconEko } from "assets/images/icons/project-icons/billPaymentProviders/power/eko.svg"
import { ReactComponent as IconEnugu } from "assets/images/icons/project-icons/billPaymentProviders/power/enugu.svg"
import { ReactComponent as IconIbadan } from "assets/images/icons/project-icons/billPaymentProviders/power/ibadan.svg"
import { ReactComponent as IconIkeja } from "assets/images/icons/project-icons/billPaymentProviders/power/ikeja.svg"
import { ReactComponent as IconJos } from "assets/images/icons/project-icons/billPaymentProviders/power/jos.svg"
import { ReactComponent as IconKaduna } from "assets/images/icons/project-icons/billPaymentProviders/power/kaduna.svg"
import { ReactComponent as IconKano } from "assets/images/icons/project-icons/billPaymentProviders/power/kano.svg"
import { ReactComponent as Iconporthc } from "assets/images/icons/project-icons/billPaymentProviders/power/porthc.svg"
import { ReactComponent as Iconyola } from "assets/images/icons/project-icons/billPaymentProviders/power/yola.svg"



import Maybe from 'components/__new/common/Maybe'

const useBillPayments = () => {
  const generateName = (name) => {
    if(!name){
      return;
    } else {
      let newName;
      
      newName = name?.replace(/_/g, ' ').replace(/^\w/, c => (c.charAt(0).toUpperCase() + c.slice(1).toLowerCase()))
      return capitalizeBillerName(newName);
    }
  }
  
  const AirtimeDataBillerIcon = ({ network, allUppercase }) => (
    <div className="flex items-center gap-2">
      <Maybe condition={network === 'mtn'}>
        <IconMtn width={22} />
      </Maybe>
      <Maybe condition={network === 'airtel'}>
        <IconAirtel width={22} />
      </Maybe>
      <Maybe condition={network === 'glo'}>
        <IconGlo width={22} />
      </Maybe>
      <Maybe condition={network === '9mobile'}>
        <IconNineMobile width={22} />
      </Maybe>
      <Maybe condition={network === 'smile'}>
        <IconSmile width={22} />
      </Maybe>
      <Maybe condition={network === 'spectranet'}>
        <IconSpectranet width={22} />
      </Maybe>
      <Maybe condition={network === 'swift'}>
        <IconSwift width={22} />
      </Maybe>
      <span className={'ml-2 inline-block ' + allUppercase && 'uppercase'}>
        {network}
      </span>
    </div>
  );

  const CableBillerIcon = ({ name, allUppercase }) => (
    <div className="flex items-center gap-2">
      <Maybe condition={name === 'dstv'}>
        <IconDstv width={22} />
      </Maybe>
      <Maybe condition={name === 'gotv'}>
        <IconGotv width={22} />
      </Maybe>
      <Maybe condition={name === 'startimes' || name === 'default'}>
        <IconStartimes width={22} />
      </Maybe>

      <span className={'ml-2 inline-block ' + allUppercase && 'uppercase'}>
        {name === 'default' ? 'startimes' : name}
      </span>
    </div>
  );

  const ElectricityBillerIcon = ({ name, allUppercase }) => (
    <div className="flex items-center gap-2">
      <Maybe condition={name === 'aba' || name === 'aba'}>
        <IconAba width={22} />
      </Maybe>
      <Maybe condition={name === 'abuja' || name === 'abuja'}>
        <IconAbuja width={22} />
      </Maybe>
      <Maybe condition={name === 'benin' || name === 'benin'}>
        <IconBenin width={22} />
      </Maybe>
      <Maybe condition={name === 'eko' || name === 'eko'}>
        <IconEko width={22} />
      </Maybe>
      <Maybe condition={name === 'enugu' || name === 'enugu'}>
        <IconEnugu width={22} />
      </Maybe>
      <Maybe condition={name === 'ibadan' || name === 'ibadan_electric'}>
        <IconIbadan width={22} />
      </Maybe>
      <Maybe condition={name === 'ikeja' || name === 'ikeja_electric'}>
        <IconIkeja width={22} />
      </Maybe>
      <Maybe condition={name === 'jos' || name === 'jos_electric'}>
        <IconJos width={22} />
      </Maybe>
      <Maybe condition={name === 'kaduna' || name === 'kaduna_electric'}>
        <IconKaduna width={22} />
      </Maybe>
      <Maybe condition={name === 'kano' || name === 'kano_electric'}>
        <IconKano width={22} />
      </Maybe>
      <Maybe condition={name === 'kedco' || name === 'kedco_electric'}>
        <IconKaduna width={22} />
      </Maybe>
      <Maybe condition={name === 'portharcourt' || name === 'portharcourt_electric'}>
        <Iconporthc width={22} />
      </Maybe>
      <Maybe condition={name === 'yola' || name === 'yola_electric'}>
        <Iconyola width={22} />
      </Maybe>
      <span className={'ml-2 inline-block ' + allUppercase && 'uppercase'}>
        {/* {name?.replace(/_/g, ' ').replace(/^\w/, c => c.toUpperCase())} */}
        {generateName(name)}
      </span>
    </div>
  );

  return {
    AirtimeDataBillerIcon,
    CableBillerIcon,
    ElectricityBillerIcon,
  };
};

export default useBillPayments;
